"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomContextVariableToJSON = exports.CustomContextVariableFromJSONTyped = exports.CustomContextVariableFromJSON = void 0;
const IssueContextVariable_1 = require("./IssueContextVariable");
const JsonContextVariable_1 = require("./JsonContextVariable");
const UserContextVariable_1 = require("./UserContextVariable");
function CustomContextVariableFromJSON(json) {
    return CustomContextVariableFromJSONTyped(json, false);
}
exports.CustomContextVariableFromJSON = CustomContextVariableFromJSON;
function CustomContextVariableFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'issue':
            return Object.assign(Object.assign({}, (0, IssueContextVariable_1.IssueContextVariableFromJSONTyped)(json, true)), { type: 'issue' });
        case 'json':
            return Object.assign(Object.assign({}, (0, JsonContextVariable_1.JsonContextVariableFromJSONTyped)(json, true)), { type: 'json' });
        case 'user':
            return Object.assign(Object.assign({}, (0, UserContextVariable_1.UserContextVariableFromJSONTyped)(json, true)), { type: 'user' });
        default:
            throw new Error(`No variant of CustomContextVariable exists with 'type=${json['type']}'`);
    }
}
exports.CustomContextVariableFromJSONTyped = CustomContextVariableFromJSONTyped;
function CustomContextVariableToJSON(value) {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'issue':
            return (0, IssueContextVariable_1.IssueContextVariableToJSON)(value);
        case 'json':
            return (0, JsonContextVariable_1.JsonContextVariableToJSON)(value);
        case 'user':
            return (0, UserContextVariable_1.UserContextVariableToJSON)(value);
        default:
            throw new Error(`No variant of CustomContextVariable exists with 'type=${value['type']}'`);
    }
}
exports.CustomContextVariableToJSON = CustomContextVariableToJSON;
//# sourceMappingURL=CustomContextVariable.js.map